export default __webpack_public_path__ + "static/media/mail_verif.593f2b14.svg";